module.exports = __webpack_public_path__ + "static/media/matilde-special-indiana-sad.285f8c4e.png";